import { getCustomerConfig } from '@pelicargo/tenants';
import { useMemo } from 'react';

import { bootReamaze } from '../../utils/reamaze';
import { useAuth } from '../auth/useAuth';
import { useFrontChat } from '../front/useFrontChat';

export const useSupportChat = ({ requestId }: { requestId?: number }) => {
  const { user } = useAuth();
  const reamaze = useMemo(() => getCustomerConfig().reamaze, []);

  const { handleChatSupport: handleFrontChat } = useFrontChat({ requestId, enabled: !reamaze });

  const handleChatSupport = () => {
    if (reamaze) {
      bootReamaze(reamaze, { email: user?.email, name: user?.full_name });
      return;
    }
    handleFrontChat();
  };

  return { handleChatSupport };
};
